import { Order } from './order';
import { OrderItem } from './order-item';
import { OrderNotification } from './order-notification';

export class OrderData {
    public Order: Order;
    public OrderItems: OrderItem[];
    public OrderNotification: OrderNotification;
}
